import React from 'react';

const challenges = [
  'Erosion of basic medical knowledge and patient trust',
  'Under developed communication skills affecting Press Ganey scores',
  'Risk of task-oriented, depersonalized care',
  'Clinical reasoning and care delivery is crumbling',
];

const ChallengeSection: React.FC = () => (
  <section id="challenge" style={{ background: '#fafbfc', padding: '4rem 0', display: 'flex', justifyContent: 'center' }}>
    <div style={{
      display: 'flex',
      alignItems: 'center',
      maxWidth: 1300,
      width: '100%',
      gap: '3rem',
      padding: '0 2rem',
      '@media (max-width: 768px)': {
        flexDirection: 'column',
        gap: '2rem',
        padding: '0 1rem',
        alignItems: 'stretch',
      }
    }}>
      <div style={{
        flex: 1,
        '@media (max-width: 768px)': {
          width: '100%',
          textAlign: 'center',
        }
      }}>
        <h2 style={{ fontSize: '2.5rem', fontWeight: 800, marginBottom: '1.5rem', '@media (max-width: 768px)': { fontSize: '2rem' } }}>
          The Challenge Facing Medical Education
        </h2>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0, fontSize: '1.25rem', color: '#222', '@media (max-width: 768px)': { fontSize: '1.05rem', textAlign: 'center' } }}>
          {challenges.map((c, i) => (
            <li key={i} style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem', justifyContent: 'center' }}>
              {c}
            </li>
          ))}
        </ul>
      </div>
      <div style={{
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 220,
        borderRadius: '3px',
        overflow: 'hidden',
        '@media (max-width: 768px)': {
          width: '100%',
          minHeight: 180,
        }
      }}>
        <img src="/silomedai-assets/images/medical-education-challenge.png" alt="Challenge Facing Medical Education" style={{ width: '100%', height: 'auto', objectFit: 'cover', borderRadius: '3px' }} />
      </div>
    </div>
  </section>
);

export default ChallengeSection; 